import { ColorPicker } from 'antd'
import { AggregationColor } from 'antd/es/color-picker/color'
import React from 'react'

export const ColorSwatch: React.FC<{
  color: string
  onChangeColor: (color: string) => void
}> = ({ color, onChangeColor }) => {
  const handleColorChange = (value: AggregationColor) => {
    onChangeColor(value.toHexString())
  }

  return <ColorPicker value={color} onChange={handleColorChange} />
}
